/**********
MLB LIVETRACKER REDUCERS
**********/

let mlbInitStateObj = {
    prevent_video: {},
    game_event: {},
    underReview: false,
    battingEvent: { fire_event: false, event_type: '', event_details: {} },
}

export const mlbLivetracker = (state = mlbInitStateObj, action) => {
    switch (action.type) {
        case 'ROUTE_CHANGE':
            return mlbInitStateObj

        case 'PREVENT_VIDEO_MLB':
            return {
                ...state,
                prevent_video: action.transition,
            }

        case 'SHOW_NOTIFICATION':
        case 'HIDE_NOTIFICATION':
            return {
                ...state,
                game_event: action.is_active,
            }

        case 'UNDER_REVIEW_OVERRIDE':
            return {
                ...state,
                underReview: action.underReview,
            }

        case 'ADD_BATTING_EVENT':
            return {
                ...state,
                battingEvent: {
                    fire_event: action.fire_event,
                    event_type: action.event_type,
                    event_details: action.event_details,
                },
            }

        case 'RESET_BATTING_FIRE_EVENT':
            return {
                ...state,
                battingEvent: {
                    ...state.battingEvent,
                    fire_event: false,
                },
            }

        case 'REMOVE_BATTING_EVENT':
            return {
                ...state,
                battingEvent: {
                    fire_event: false,
                    event_type: '',
                    event_details: {},
                },
            }

        default:
            return state
    }
}
